<!-- bloc de gauche -->
<ng-container *ngIf="bloc === 'gauche'">
    <div>
        <div class="grid justify-items-center">
            <div class="font-medium mb-5 hidden md:block text-center text-secondary" translate>
                lingueopro.dashboard.upcoming_sessions.Passage du LILATE
            </div>
            <div class="font-extrabold text-2xl text-center" translate>
                <span translate>lilate.dashboard.waiting</span><br />
                <span translate>lilate.dashboard.planning</span>
            </div>
        </div>
    </div>

    <button (click)="bookLilate(lilate)" class="w-full text-green-100 bg-green-500 mt-10 defaut-btn"  translate>
        <span translate>
            lilate-exam.session-content.bootime.pending
        </span>
    </button>
</ng-container>

<!-- bloc de droite -->
<ng-container *ngIf="bloc === 'droite'">
    <div class="mt-2 leading-relaxed text-gray-700" translate [translateParams]="{end: lilate.validity_period_to | date:'dd/MM/yyyy'}">lilate.dashboard.training.end.rec.card</div>
    <div class="mt-2 leading-relaxed text-gray-700" translate>lilate.dashboard.bookNow.rec.card</div>
    <div *ngIf="(lilate.status == 'booked' || lilate.status == 'identity_issue') && !isPendingAssessment">
        <div class="booked-guidance" *ngIf="!providerRequirements" translate>
            <span translate>lilate-exam.session-content.bootime.pending</span>
            </div>
    </div>
    <!-- <div class="flex items-center mt-10">
        <div class="font-medium text-secondary" translate>lilate.dashboard.planningSteps</div>
        <div class="flex-auto ml-2 border-b-2"></div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-y-4 mt-6">
        <div class="flex items-center">
            <mat-icon class="icon-size-5" [ngClass]="{'text-green-600': isStepBirthdateDone }"
                >
                <svg id="badge-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd" />
                </svg></mat-icon>
            <div class="ml-2" [ngClass]="{'line-through': isStepBirthdateDone }" translate>
                lilate.dashboard.verifyIdentity</div>
        </div>
        <div class="flex items-center">
            <mat-icon class="icon-size-5" [ngClass]="{'text-green-600': isStepLevelDone }"
                >
                <svg id="badge-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd" />
                </svg></mat-icon>
            <div class="ml-2" [ngClass]="{'line-through': isStepLevelDone }" translate>lilate.dashboard.indicateLevel
            </div>
        </div>

        <div class="flex items-center">
            <mat-icon class="icon-size-5" [ngClass]="{'text-green-600': isStepBusinessDone }"
                >
                <svg id="badge-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd" />
                </svg></mat-icon>
            <div class="ml-2" [ngClass]="{'line-through': isStepBusinessDone }" translate>
                lilate.dashboard.indicateBusinessSector</div>
        </div>
        <div class="flex items-center">
            <mat-icon class="icon-size-5" [ngClass]="{'text-green-600': isStepPhotoDone }"
                >
                <svg id="badge-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd" />
                </svg></mat-icon>
            <div class="ml-2" [ngClass]="{'line-through': isStepPhotoDone }" translate>
                lilate.dashboard.validatePhotoIdentity</div>
        </div>
        <div class="flex items-center">
            <mat-icon class="icon-size-5" >
                <svg id="badge-check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd" />
                </svg></mat-icon>
            <div class="ml-2" translate>lilate.dashboard.chooseDateTime</div>
        </div>
    </div> -->
</ng-container>